import React from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { List, Typography, Button, Modal, message } from 'antd';
import { PlusOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { useMutation, useQuery } from '@apollo/client';
import {
  GET_OVERRIDDEN_SCOPES_BY_ROLE,
  DELETE_OVERRIDDEN_SCOPES_BY_ROLE,
} from '../../../gql/projectCategories';

const { Text } = Typography;
const TabRoles = () => {
  const { id } = useParams();
  const history = useHistory();
  const { data, loading } = useQuery(GET_OVERRIDDEN_SCOPES_BY_ROLE, {
    variables: { state: 'ALL', ids: [id] },
  });
  // const [disableRole, { loading: updateLoading }] = useMutation(DISABLE_ROLE, {
  //   refetchQueries: [{ query: GET_ROLES, variables: { state: 'ALL' } }],
  // });
  const [deleteRole, { loading: deleteLoading }] = useMutation(
    DELETE_OVERRIDDEN_SCOPES_BY_ROLE,
    {
      refetchQueries: [
        {
          query: GET_OVERRIDDEN_SCOPES_BY_ROLE,
          variables: { state: 'ALL', ids: [id] },
        },
      ],
    }
  );

  const listActions = ({ item }) => {
    return [
      <Link
        key="edit"
        to={`/system-setting/project-categories/${id}/roles/${item.id}`}
      >
        Edit
      </Link>,
      <Button
        type="link"
        key={item.id}
        onClick={() => {
          Modal.confirm({
            title: `${item.role.name}`,
            icon: <ExclamationCircleOutlined />,
            content: 'Confirm to delete?',
            cancelButtonProps: {
              loading: deleteLoading,
            },
            okButtonProps: {
              loading: deleteLoading,
            },
            onOk: async () => {
              try {
                await deleteRole({
                  variables: {
                    input: {
                      id: item.id,
                    },
                  },
                });
                message.success(`${item.role.name} successfully deleted`);
              } catch (error) {
                console.log(error);
              }
            },
          });
        }}
      >
        Delete{' '}
      </Button>,
    ];
  };

  return (
    <>
      <Text
        type="secondary"
        style={{ display: 'block', paddingBottom: '16px' }}
      >
        To override the access right of roles in the project category
      </Text>
      <Button
        type="dashed"
        style={{ width: '100%', marginBottom: 8 }}
        onClick={() => {
          history.push(`/system-setting/project-categories/${id}/roles/add`);
        }}
      >
        <PlusOutlined />
        Add
      </Button>
      <List
        itemLayout="horizontal"
        dataSource={
          loading
            ? []
            : data.projectCategories[0].overriddenScopesByRoleInProjectCategory
        }
        renderItem={(item) => (
          <List.Item actions={listActions({ item })}>
            <List.Item.Meta
              title={item.role.name}
              // description={item.description}
            />
          </List.Item>
        )}
      ></List>
    </>
  );
};

export default TabRoles;
